/* eslint-disable consistent-return */
/* eslint-disable no-alert */
/* eslint-disable operator-assignment */
/* eslint-disable import/no-named-as-default-member */
import { call, put, cancelled, take, select } from 'redux-saga/effects'
import { eventChannel } from 'redux-saga'
import moment from 'moment'
import Immutable from 'seamless-immutable'
import firebase from '../config/firebase'
import MerchantSettlementActions from '../reducers/merchantSettlementReducer'

import utils from '../utils'

const observer = ref => {
  const listener = eventChannel(emit => {
    const subscriber = ref.onSnapshot(querySnapshot => {
      const merchantSettlements = {}

      querySnapshot.forEach(doc => {
        merchantSettlements[doc.id] = { ...doc.data(), id: doc.id }
      })

      emit(merchantSettlements)
    }, err => {
      emit(new Error(err))
    })

    return () => subscriber
  })
  return listener
}

export function* syncMerchantSettlements() {
  const merchantSettlementsRef = firebase.firestore().collection('merchant_settlements').orderBy('created_at')
  const channel = yield call(observer, merchantSettlementsRef)

  yield put(MerchantSettlementActions.setLoading(true))

  try {
    while (true) {
      const merchantSettlements = yield take(channel)

      yield put(MerchantSettlementActions.setMerchantSettlements(merchantSettlements))
      yield put(MerchantSettlementActions.setLoading(false))
    }
  } finally {
    yield put(MerchantSettlementActions.setLoading(false))

    if (yield cancelled()) {
      channel.close()
    }
  }
}

function* fetchRestaurants() {
  try {
    const dbRef = firebase
      .database()
      .ref('restaurants')
    const data = yield call([dbRef, dbRef.once], 'value')
    const restaurants = {}

    data.forEach(restaurant => {
      restaurants[restaurant.key] = { ...restaurant.val() }
    })

    yield put(MerchantSettlementActions.setAllRestaurants(restaurants))

    return restaurants
  } catch (error) {
    alert(error)
  }
}

export function* fetchPayLaterOrders({ startFrom, endAt }) {
  yield put(MerchantSettlementActions.setLoading(true))

  const start = Number(moment(startFrom).format('x'))
  const end = Number(moment(endAt).endOf('day').format('x'))

  const dbRef = firebase
    .database()
    .ref('orders')
    .orderByChild('created_at')
    .startAt(start)
    .endAt(end)

  try {
    const merchants = {}
    const data = yield call([dbRef, dbRef.once], 'value')
    const { allRestaurantsLoaded, allRestaurants } = yield select(state => state.merchantSettlements)
    const restaurants = allRestaurantsLoaded ?  allRestaurants : yield call(fetchRestaurants)

    data.forEach(res => {
      const order =  res.val()
      const { restaurant, status, sub_total: subTotal, discount_rate: discountRate } = order
      const { branch, key: merchantKey } = restaurant

      if (branch.merchant_settlement && status === 'delivered') {
        const { merchantDiscount } = utils.order.getOrderDiscount(order)
        const dynamicFees = utils.order.serializeDynamicFees(branch.dynamic_fees)
        const restaurantData = restaurants[merchantKey]
        const branchData = restaurantData.branches[branch.key]
        const vatRate = restaurant.vat || 0

        const subTotalAfterMerchantDiscount = subTotal - merchantDiscount
        // const vatFee = subTotalAfterMerchantDiscount * (vatRate / 100)
        const vatFee = subTotal * (vatRate / 100)
        const commissionRate = Number(discountRate)
        // const commissionFee = subTotalAfterMerchantDiscount * (commissionRate / 100)
        const commissionFee = subTotal * (commissionRate / 100)
        const commissionWithVat = commissionFee * 1.1
        const commission = branchData.merchant_settlement_type === 'full' ? 0 : commissionWithVat
        const merchantTotal = subTotalAfterMerchantDiscount + vatFee
        const merchantGrandTotal = merchantTotal - commission + dynamicFees.merchantFees.totalAmount

        const branchABANumber = branchData.aba_account_number || '--'
        const branchABAName = branchData.aba_account_name || '--'

        const defaultMerchant = { key: merchantKey, name: restaurant.name, branches: {} }
        const defaultBranch = {
          key: branch.key,
          name: branch.name,
          aba_account_name: branchABANumber,
          aba_account_number: branchABAName,
          order_count: 0,
          total_amount: 0,
        }

        merchants[merchantKey] = merchants[merchantKey] || defaultMerchant
        merchants[merchantKey].branches[branch.key] = merchants[merchantKey].branches[branch.key] || defaultBranch
        merchants[merchantKey].branches[branch.key].order_count +=  1
        merchants[merchantKey].branches[branch.key].total_amount += utils.helpers.convertToFixedTwo(merchantGrandTotal)
      }
    })

    yield put(MerchantSettlementActions.setRestaurants(merchants))
    yield put(MerchantSettlementActions.setLoading(false))

  } catch (error) {
    alert(error)
    yield put(MerchantSettlementActions.setLoading(false))
  }
}

export function* saveMerchantSettlement({ id, data, startFrom, endAt, callBack }) {
  try {
    yield put(MerchantSettlementActions.setSaving(true))
    const date = moment().format('x')

    const doc = firebase
        .firestore()
        .collection('merchant_settlements')
        .doc(id)

    const merchantSettlementData = {
      created_at: date,
      updated_at: date,
      restaurants: data,
      start_at: moment(startFrom).format('x'),
      end_at: moment(endAt).format('x')
    }

    yield call([doc, doc.set], merchantSettlementData)
    yield put(MerchantSettlementActions.setSaving(false))
    yield call(callBack)
  } catch (error) {
    alert(error)
    yield put(MerchantSettlementActions.setSaving(false))
  }
}

export function* paidMerchant({ merchantSettlement, restaurant, branch }) {
  try {
    yield put(MerchantSettlementActions.setSaving(true))
    const date = moment().format('x')

    let updates = Immutable(merchantSettlement)

    updates = updates
      .setIn(['restaurants', restaurant.key, 'branches', branch.key, 'status'], 'paid')
      .setIn(['restaurants', restaurant.key, 'branches', branch.key, 'paid_at'], date)

    const doc = firebase
        .firestore()
        .collection('merchant_settlements')
        .doc(merchantSettlement.id)

    yield call([doc, doc.update], updates)
    yield put(MerchantSettlementActions.setSaving(false))
  } catch (error) {
    alert(error)
    console.log(error)
  }
}



// WEBPACK FOOTER //
// ./src/sagas/merchantSettlementSaga.js